import React from 'react'
import Stars from 'containers/QuickShopProductSidebar/components/Reviews/components/Stars'
import extractDateFromString from 'containers/QuickShopProductSidebar/components/Reviews/utils/extract-date-from-string'

const MAX_STARS = 5

const ReviewCard = ({ review }) => {
  const rating = review.rating || 0

  return (
    <div className='jgm-review-container'>
      <div className='jdgm-rev__author-wrapper'>
        {review.author}
      </div>
      <div className='jdgm-row-rating'>
        <span className='jdgm-rev__rating'>
          <Stars maxStars={MAX_STARS} rating={rating} />
        </span>
        <span className='jdgm-rev__timestamp'>
          {extractDateFromString(review.timestamp)}
        </span>
      </div>
      <div className='jdgm-rev__content'>
        <b className='jdgm-rev__title'>{review.title}</b>
        <div className='jdgm-rev__body'>
          <p>{review.content}</p>
        </div>
      </div>
    </div>
  )
}

export default ReviewCard
